import { trackPageViewV2 } from "@/services/analytics-adapter";
import { useEffect } from "react";
import MyCareCardVouchers from "../../components/MyCareCardVouchers";

export default function MyCareCardVouchersPage() {
  useEffect(() => {
    trackPageViewV2({
      pageName: "More:My CareCard vouchers",
      pageSubSection1: "More",
      pageSubSection2: "More:My CareCard vouchers",
      pageCategory: "More",
    });
  }, []);
  return <MyCareCardVouchers />;
}
